export default __webpack_public_path__ + "static/media/gallery_three.1c191e27.jpg";